import React from "react";
import { TableProps, Tag, Button, Popconfirm, Tooltip } from "antd";
import { Pencil, Trash2 } from "lucide-react";
import { IFaq } from "../../../hooks/api/faq/callbacks";

interface GetFaqColumnsProps {
  onEdit: (record: IFaq) => void;
  onDelete: (id: string) => void;
}

export const getFaqColumns = ({
  onEdit,
  onDelete,
}: GetFaqColumnsProps): TableProps<IFaq>["columns"] => [
  {
    title: "Order",
    dataIndex: "order",
    key: "order",
    width: 80,
    render: (order: number) => <span className="font-semibold text-slate-700">{order ?? 0}</span>,
  },
  {
    title: "Question",
    dataIndex: "question",
    key: "question",
    render: (text: string) => (
      <span className="font-medium text-slate-800">{text}</span>
    ),
  },
  {
    title: "Answer",
    dataIndex: "answer",
    key: "answer",
    ellipsis: true,
    render: (text: string) => (
      <span className="text-slate-600 text-sm">{text}</span>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 100,
    render: (status: boolean) => (
      <Tag color={status ? "green" : "red"}>{status ? "Active" : "Inactive"}</Tag>
    ),
  },
  {
    title: "Action",
    key: "action",
    width: 100,
    render: (_, record) => (
      <div className="flex items-center gap-1">
        <Tooltip title="Edit">
          <Button
            size="small"
            icon={<Pencil size={14} />}
            onClick={() => onEdit(record)}
            className="text-slate-500 hover:text-blue-600 border-none shadow-none bg-transparent"
          />
        </Tooltip>
        <Tooltip title="Delete">
          <Popconfirm
            title="Delete this FAQ?"
            description="This action cannot be undone."
            onConfirm={() => onDelete(record._id)}
            okText="Delete"
            okType="danger"
            cancelText="Cancel"
          >
            <Button
              size="small"
              icon={<Trash2 size={14} />}
              className="text-slate-500 hover:text-red-600 border-none shadow-none bg-transparent"
            />
          </Popconfirm>
        </Tooltip>
      </div>
    ),
  },
];
